import React from 'react';
export function Edit2Liner24() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91724 3.78747C9.23974 5.85747 10.9197 7.43997 13.0047 7.64997M2.25 16.5H15.75M9.94525 2.69998L3.78775 9.21748C3.55525 9.46498 3.33025 9.95248 3.28525 10.29L3.00775 12.72C2.91025 13.5975 3.54025 14.1975 4.41025 14.0475L6.82525 13.635C7.16275 13.575 7.63525 13.3275 7.86775 13.0725L14.0253 6.55498C15.0903 5.42998 15.5703 4.14748 13.9128 2.57998C12.2628 1.02748 11.0103 1.57498 9.94525 2.69998Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}